import React from 'react';
import './LoadingSpinner.css';

interface LoadingSpinnerProps {
  /** Omit or leave default for race/app loading. Pass "" to show only the spinner (caption rendered by parent). */
  message?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message = 'Loading race data...',
}) => {
  return (
    <div className="loading-container">
      <div className="loading-spinner">
        <div className="spinner"></div>
      </div>
      {message ? <p className="loading-message">{message}</p> : null}
    </div>
  );
};

export default LoadingSpinner;
